import {Component, OnDestroy, OnInit} from '@angular/core';
import {AgrisService} from '../../../../../services';
import {Subscription} from 'rxjs/Subscription';
import {OficinaComercialViewModel, SucursalComercialViewModel} from '../../AgrisViewModels';
import {MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-selector-ofic-suc-dialog',
  templateUrl: './selector-ofic-suc-dialog.component.html',
  styleUrls: ['./selector-ofic-suc-dialog.component.scss', '../../agris-common-styles.scss']
})
export class SelectorOficSucDialogComponent implements OnDestroy {

  oficina: OficinaComercialViewModel = null;
  sucursal: SucursalComercialViewModel = null;

  sub: Subscription[] = [];

  loadingSucursales = false;
  listaSucursales: SucursalComercialViewModel[] = [];

  constructor(
    public agrisService: AgrisService,
    private dialogRef: MdDialogRef<SelectorOficSucDialogComponent>
  ) {
    // oficina
    this.sub.push(
      agrisService.oficina$.subscribe(x => {
        this.oficina = x;
        this.loadSucursales(false);
      })
    );

    // sucursal
    this.sub.push(
      agrisService.sucursal$.subscribe(x => {
        this.sucursal = x;
      })
    );
  }

  ngOnDestroy() {
    this.sub.forEach(x => x.unsubscribe())
  }

  onSelectedOficina(ofi: OficinaComercialViewModel) {
    this.oficina = ofi;
    this.loadSucursales()
  }

  loadSucursales(setDefault = true): void {
    if (this.oficina !== null) {
      this.agrisService.getSucursales(this.oficina.Id).subscribe(y => {
        this.listaSucursales = y;
        if (setDefault) {
          this.sucursal = this.listaSucursales[0];
        }
      });
    }
  }

  onSubmit() {
    this.agrisService.setOficina(this.oficina);
    this.agrisService.setSucursal(this.sucursal);
    this.dialogRef.close()
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-selector-ofic-suc/selector-ofic-suc-dialog/selector-ofic-suc-dialog.component.ts